import { useState, type SyntheticEvent } from 'react';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { Container, Link, Stack, Tab, Tabs, Typography } from '@mui/material';
import { Banner } from './components/banner';
import { CoursesList } from './components/courses-list';
import { ExternalUrls } from '@/constants';
import {
  useCompletedCoursesIndex,
  useOngoingCoursesIndex,
} from '@/data/corporate-university/course';
import { useTrailsIndex } from '@/data/corporate-university/trails';

enum TabIds {
  List = 'list',
  InProgress = 'inProgress',
  Completed = 'completed',
}

const TabsConfig = {
  [TabIds.List]: {
    label: 'Catálogo de cursos',
    value: TabIds.List,
  },
  [TabIds.InProgress]: {
    label: 'Cursos em andamento',
    value: TabIds.InProgress,
  },
  [TabIds.Completed]: {
    label: 'Cursos concluídos',
    value: TabIds.Completed,
  },
};

export const CorporateUniversity = () => {
  const [tab, setTab] = useState<string>(TabIds.List);
  const { trails, isLoading } = useTrailsIndex();
  const { ongoingCourses, isLoading: isLoadingOngoingCourses } =
    useOngoingCoursesIndex();
  const { completedCourses, isLoading: isLoadingCompletedCourses } =
    useCompletedCoursesIndex();

  const handleTabChange = (_: SyntheticEvent, newValue: TabIds) => {
    setTab(newValue);
  };

  return (
    <>
      <Banner />
      <TabContext value={tab}>
        <Container maxWidth="lg" sx={{ py: 3 }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            mb={3}
            flexWrap="wrap"
          >
            <Tabs value={tab} onChange={handleTabChange}>
              <Tab label={TabsConfig[TabIds.List].label} value={TabIds.List} />
              <Tab
                label={TabsConfig[TabIds.InProgress].label}
                value={TabIds.InProgress}
              />
              <Tab
                label={TabsConfig[TabIds.Completed].label}
                value={TabIds.Completed}
              />
            </Tabs>
            <Typography>
              Tem dúvidas ou precisa de ajuda com progresso ou certificados?{' '}
              <Link href={ExternalUrls.Support} target="_blank">
                Fale com nosso time
              </Link>
            </Typography>
          </Stack>
          <TabPanel value={TabIds.List} sx={{ p: '0px' }}>
            <CoursesList
              courses={trails ?? []}
              isLoading={isLoading}
              goToTrails={() => setTab(TabIds.List)}
              isTrails
            />
          </TabPanel>
          <TabPanel value={TabIds.InProgress} sx={{ p: '0px' }}>
            <CoursesList
              courses={ongoingCourses ?? []}
              isLoading={isLoadingOngoingCourses}
              goToTrails={() => setTab(TabIds.List)}
            />
          </TabPanel>
          <TabPanel value={TabIds.Completed} sx={{ p: '0px' }}>
            <CoursesList
              courses={completedCourses ?? []}
              isLoading={isLoadingCompletedCourses}
              goToTrails={() => setTab(TabIds.List)}
              isCompleted
            />
          </TabPanel>
        </Container>
      </TabContext>
    </>
  );
};
